(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-data/assets/javascripts/reducers/chat-rooms-reducer.js') >= 0) return;  svs.modules.push('/components/chat/chat-data/assets/javascripts/reducers/chat-rooms-reducer.js'); 
'use strict';

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  CHAT_PAGE_LOAD_INIT,
  CHAT_PAGE_LOAD_SUCCESS,
  CHAT_PAGE_LOAD_FAILURE,
  CHAT_PAGE_LOAD_CLOSED,
  CHAT_GET_UNREAD_SUCCESS,
  CHAT_MARK_READ_LOCAL,
  CHAT_MARK_READ_SUCCESS,
  CHAT_RECEIVE_MESSAGE,
  CHAT_GET_UNREAD_BY_ROOM_SUCCESS,
  CHAT_PURGE_ROOM,
  CHAT_TOGGLE_STATUS_SUCCESS
} = svs.components.chat.chatData.actions;
const {
  constants
} = svs.components.chat.chatData;
const chatRoomsReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let action = arguments.length > 1 ? arguments[1] : undefined;
  const roomId = action.roomId;
  switch (action.type) {
    case CHAT_PAGE_LOAD_INIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          loading: true,
          error: null,
          status: constants.ROOM_STATUS_OPEN
        })
      });
    case CHAT_PAGE_LOAD_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          loading: false,
          error: action.error
        })
      });
    case CHAT_PAGE_LOAD_CLOSED:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          loading: false,
          status: 'Closed'
        })
      });
    case CHAT_PAGE_LOAD_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          loading: false,
          hasLoadedEverything: action.hasLoadedEverything,
          name: action.room.name,
          isUserBlocked: action.room.isCurrentChatRoomMemberBlocked,
          status: action.room.status
        })
      });
    case CHAT_PURGE_ROOM:
      {
        const _ref = "".concat(action.roomId),
          {
            [_ref]: deleteMe
          } = state,
          saveUs = _objectWithoutProperties(state, [_ref].map(_toPropertyKey));
        return saveUs;
      }
    case CHAT_GET_UNREAD_SUCCESS:
      {
        return Object.keys(action.data).reduce((acc, roomId) => _objectSpread(_objectSpread({}, acc), {}, {
          [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
            unread: action.data[roomId].unread,
            latestRead: action.data[roomId].latestRead,
            latestReadServer: action.data[roomId].latestRead
          })
        }), state);
      }
    case CHAT_GET_UNREAD_BY_ROOM_SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
            unread: action.data[roomId].unread
          })
        });
      }
    case CHAT_MARK_READ_LOCAL:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
            unread: action.unread,
            latestRead: action.latestRead
          })
        });
      }
    case CHAT_RECEIVE_MESSAGE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
            unread: ((state[roomId] || {}).unread || 0) + action.increaseUnreadCount
          })
        });
      }
    case CHAT_MARK_READ_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          latestReadServer: action.messageId
        })
      });
    case CHAT_TOGGLE_STATUS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        [roomId]: _objectSpread(_objectSpread({}, state[roomId]), {}, {
          status: action.newStatus
        })
      });
    default:
      return state;
  }
};
setGlobal('svs.components.chat.chatData.reducers.chatRoomsReducer', chatRoomsReducer);
 })(window);